const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_BID_TASKS':
      return action.bidTasks
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/bidTasks.jsx